import React, { useState } from 'react';
import AnimateHeight from 'react-animate-height';
import { Button } from 'react-bootstrap';
import styled from 'styled-components';

type Props = {
    title?: string | React.ReactNode;
    headerButton?: React.ReactNode;
    children?: React.ReactNode;
};


const Container = (props: Props) => {
    const { title, children, headerButton } = props;
    const [closeFlg, setActive] = useState(false);
    const contentsAccodionEvent = () => {
        setActive(!closeFlg)
    }
    const duration = 400;
    const contentsHeight = closeFlg ? '0%' : 'auto'

    return (
        <div className='mainContents__container'>
            <h2 className='mainContents__container__title'>
                {title}
                <HeaderButtonAreaWithStyled>
                    {headerButton ? headerButton :
                        (
                            <Button
                                variant='outline-secondary'
                                size='sm'
                                onClick={contentsAccodionEvent}
                            >
                                OPEN / CLOSE
                            </Button>
                        )
                    }
                </HeaderButtonAreaWithStyled>
            </h2>
            <AnimateHeight
                id='example-panel'
                className='mainContents__container__body'
                duration={duration}
                height={contentsHeight}
            >
                {children}
            </AnimateHeight>
        </div>
    );
};

const HeaderButtonAreaWithStyled = styled.div`
    position: absolute;
    right: 0;
    bottom: 6px;
    & .btn {
        margin-left: 5px;
    }
` 

export default Container;